import React, { useState } from "react"
import { Grid, Typography, FormControl, Box } from "@material-ui/core"
import { SwitchControl } from "../../common/Switch"
import { useTranslation } from "react-i18next"
import useStyles from "./styles"
import AddUserRow from "./AddUserRow"
import AssigntoMultiSelect from "./AssigntoMultiSelect"

function AutoAssignmentView(props) {
	const { formik, assignmentDetails, setAssignmentDetails, setIsAssignmentDone, validatePercentage, isAutoAssignmentFormInValid } =
		props?.data

	const classes = useStyles()

	const [t] = useTranslation("global")

	const addNewRow = (e) => {
		setAssignmentDetails((prevState) => ({
			userRow: [
				...prevState.userRow,
				{
					index: Math.random(),
					assignTo: "",
					percentage: "",
					assignToErr: false,
					percentageErr: false,
					assignToErrMsg: "",
					percentageErrMsg: "",
				},
			],
		}))
	}
	const deteteRow = (index) => {
		setIsAssignmentDone(false)
		setAssignmentDetails({
			userRow: assignmentDetails?.userRow?.filter((v, vindex) => index !== vindex),
		})
	}

	const handleAssignmentDetails = (e, arIdx, objIdx, type) => {
		if (assignmentDetails?.userRow?.[arIdx]?.index === objIdx) {
			let tempAssignments = _.cloneDeep(assignmentDetails)
			switch (type) {
				case "select":
					tempAssignments.userRow[arIdx] = { ...assignmentDetails?.userRow?.[arIdx], assignTo: e.target.value }
					setAssignmentDetails(tempAssignments)
					break
				case "text":
					if (!validatePercentage(e.target.value)) {
						tempAssignments.userRow[arIdx] = {
							...assignmentDetails?.userRow?.[arIdx],
							percentage: e.target.value,
							percentageErr: true,
							percentageErrMsg: t("review.reviewForm.textError"),
						}
					} else {
						tempAssignments.userRow[arIdx] = {
							...assignmentDetails?.userRow?.[arIdx],
							percentage: e.target.value,
							percentageErr: false,
							percentageErrMsg: "",
						}
					}

					setAssignmentDetails(tempAssignments)
					break
				default:
					console.log("Invalid type")
			}
		}
	}

	return (
		<>
			<Grid container alignItems="center" className={classes.marginBottom}>
				<Grid item xs={8}>
					<FormControl fullWidth>
						<Typography variant="subtitle1">{t("review.reviewForm.assignFileEqually")}</Typography>
					</FormControl>
				</Grid>
				<Grid item xs={4} justifyContent="flex-end" alignItems="center" className={classes.switchwrapper}>
					<SwitchControl
						name="assignFileEqually"
						state={formik.values.file_equal_assignment}
						setState={() => {
							formik.setFieldValue("file_equal_assignment", !formik.values.file_equal_assignment)
						}}
					/>
				</Grid>
			</Grid>
			{isAutoAssignmentFormInValid && (
				<Box component="p" style={{ color: "red" }}>
					{t("review.reviewForm.errorMessage")}
				</Box>
			)}
			{formik.values.file_equal_assignment ? (
				<AssigntoMultiSelect data={props?.data} />
			) : (
				<AddUserRow handleAssignmentDetails={handleAssignmentDetails} addRow={addNewRow} deleteRow={deteteRow} data={props?.data} />
			)}
		</>
	)
}

export default AutoAssignmentView
